export class AdditionalIncomeConfig {
  public static readonly FREELANCE_JOB_THRESHOLD = 600000;
  public static readonly ITEMS_LIMIT_IN_SUBSECTION_SOCIAL_INCOME = 10;
  public static readonly ITEMS_LIMIT_IN_SUBSECTION_PENSION_INCOME = 10;
  public static readonly ITEMS_LIMIT_IN_SUBSECTION_FREELANCE_INCOME = 2;
  public static readonly ITEMS_LIMIT_IN_SUBSECTION_CRYPTOCURRENCY_INCOME = 20;
}
